import React from 'react'
import { Modal, Card, Icon } from 'antd'

const { Meta } = Card

const ModeSelectionModal = ({ visible, onSelectMode, onCancel }) => {
  return (
    <Modal
      visible={visible}
      title="Select Creation Mode"
      onCancel={onCancel}
      footer={null}
      centered
      width={700}
      className="mode-selection-modal"
    >
      <div
        style={{
          display: 'flex',
          gap: '24px',
          padding: '20px',
          justifyContent: 'center'
        }}
      >
        <Card
          hoverable
          style={{ width: 300 }}
          onClick={() => onSelectMode('manual')}
        >
          <div
            style={{
              textAlign: 'center',
              marginBottom: '20px',
              fontSize: '48px',
              color: '#1890ff'
            }}
          >
            <Icon type="ordered-list" />
          </div>
          <Meta
            title="Manual Mode"
            description="Create your video step-by-step. Full control over every scene, precise edits, and detailed customization as you go."
          />
        </Card>

        <Card
          hoverable
          style={{ width: 300 }}
          onClick={() => onSelectMode('draft')}
        >
          <div
            style={{
              textAlign: 'center',
              marginBottom: '20px',
              fontSize: '48px',
              color: '#52c41a'
            }}
          >
            <Icon type="rocket" />
          </div>
          <Meta
            title="Draft Mode"
            description="Fast-track your setup. Configure everything on one screen while AI generates shots in the background."
          />
        </Card>
      </div>
    </Modal>
  )
}

export default ModeSelectionModal
